(function () {
    'use strict';

    document.querySelectorAll('[data-eb-widget]').forEach(function (widget) {
      if (widget.dataset.ebInit) return;
      widget.dataset.ebInit = '1';

      var card1 = widget.querySelector('[data-card="1"]');
      var card2 = widget.querySelector('[data-card="2"]');
      var multiList = widget.querySelector('[data-role="multi-list"]');
      var addBedButton = widget.querySelector('[data-role="add-bed"]');
      var cta = widget.querySelector('[data-role="cta"]');
      var singleSelect = widget.querySelector('[data-role="single-variant"]');
      var priceSuffix = (window.EB_BUNDLE_CFG && window.EB_BUNDLE_CFG.priceSuffix) || '';

      if (!card1 || !card2 || !multiList || !cta || !singleSelect) return;

      function formatMoneyFromCents(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          var fallbackFormat = '$\u007B\u007Bamount\u007D\u007D';
          return window.Shopify
            .formatMoney(cents, window.Shopify.money_format || fallbackFormat)
            .replace(/<[^>]*>/g, '');
        }

        var currency =
          (window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active) ||
          'USD';

        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      function updateSinglePrice() {
        var option = singleSelect.options[singleSelect.selectedIndex];
        if (!option) return;

        var priceCents = parseInt(option.dataset.priceCents, 10) || 0;
        var compareCents =
          parseInt(option.dataset.compareCents, 10) || priceCents;
        var hasDiscount = option.dataset.hasDiscount === '1';
        var html = '';

        if (hasDiscount) {
          html +=
            '<span class="eb-strike">' +
            formatMoneyFromCents(compareCents) +
            '</span>';
        }

        html +=
          formatMoneyFromCents(priceCents) +
          '<span class="eb-price-period">' +
          priceSuffix +
          '</span>';

        var mainPrice = card1.querySelector('.eb-price-main');
        var previewPrice = card1.querySelector('.eb-preview-price');

        if (mainPrice) mainPrice.innerHTML = html;
        if (previewPrice) previewPrice.innerHTML = html;
      }

      function getSelectedMultiOptions() {
        var options = [];

        multiList
          .querySelectorAll('[data-role="multi-variant"]')
          .forEach(function (select) {
            var option = select.options[select.selectedIndex];
            if (option) options.push(option);
          });

        return options;
      }

      function updateMultiPrices() {
        var options = getSelectedMultiOptions();
        if (!options.length) return;

        var totalCompare = 0;
        var totalSale = 0;

        options.forEach(function (option) {
          var priceCents = parseInt(option.dataset.priceCents, 10) || 0;
          var compareCents =
            parseInt(option.dataset.compareCents, 10) || priceCents;
          var discountedCents =
            parseInt(option.dataset.discountedCents, 10) || priceCents;

          // Reference price for the 2+ Beds card is the regular per-pad price,
          // not the compare-at price, so the strike is never a compounded discount.
          totalCompare += priceCents;
          totalSale += discountedCents;

          var line = option.closest('.eb-bed-line');
          if (!line) return;

          var priceElement = line.querySelector('.eb-line-price');
          if (!priceElement) return;

          var lineHtml =
            '<span class="eb-line-sale">' +
            formatMoneyFromCents(discountedCents) +
            '</span>';

          if (priceCents > discountedCents) {
            lineHtml +=
              '<span class="eb-line-strike">' +
              formatMoneyFromCents(priceCents) +
              '</span>';
          }

          priceElement.innerHTML = lineHtml;
        });

        var averageCompare = Math.round(totalCompare / options.length);
        var averageSale = Math.round(totalSale / options.length);
        var topHtml = '';

        if (averageCompare > averageSale) {
          topHtml +=
            '<span class="eb-strike">' +
            formatMoneyFromCents(averageCompare) +
            '</span>';
        }

        topHtml +=
          formatMoneyFromCents(averageSale) +
          '<span class="eb-price-period">' +
          priceSuffix +
          '</span>';

        var mainPrice = card2.querySelector('.eb-body .eb-price-main');
        var previewPrice = card2.querySelector('.eb-preview-price');

        if (mainPrice) mainPrice.innerHTML = topHtml;
        if (previewPrice) previewPrice.innerHTML = topHtml;
      }

      function updateIncludedScrollbar(section) {
        if (!section) return;

        var card = section.closest('.eb-card');
        var track = section.querySelector('.eb-included-grid');
        var scrollbar = section.querySelector('.eb-included-scrollbar');
        var thumb = section.querySelector('.eb-included-scrollbar-thumb');

        if (!card || !track || !scrollbar || !thumb) return;

        if (!card.classList.contains('is-selected')) {
          scrollbar.style.display = 'none';
          return;
        }

        var maxScroll = track.scrollWidth - track.clientWidth;

        if (maxScroll <= 0) {
          scrollbar.style.display = 'none';
          return;
        }

        scrollbar.style.display = 'block';

        var scrollbarWidth = scrollbar.clientWidth;
        var visibleRatio = track.clientWidth / track.scrollWidth;
        var thumbWidth = Math.max(scrollbarWidth * visibleRatio, 28);
        var maxThumbTravel = scrollbarWidth - thumbWidth;
        var scrollRatio = track.scrollLeft / maxScroll;
        var thumbX = maxThumbTravel * scrollRatio;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform =
          'translate3d(' + thumbX + 'px, 0, 0)';
      }

      function updateIncludedScrollbars() {
        widget
          .querySelectorAll('.eb-included')
          .forEach(function (section) {
            updateIncludedScrollbar(section);
          });
      }

      function initIncludedScrollbars() {
        widget
          .querySelectorAll('.eb-included')
          .forEach(function (section) {
            var track = section.querySelector('.eb-included-grid');
            if (!track) return;

            var ticking = false;

            function requestUpdate() {
              if (ticking) return;
              ticking = true;

              window.requestAnimationFrame(function () {
                updateIncludedScrollbar(section);
                ticking = false;
              });
            }

            track.addEventListener('scroll', requestUpdate, { passive: true });
            track.addEventListener('touchmove', requestUpdate, {
              passive: true
            });
            track.addEventListener('pointermove', requestUpdate, {
              passive: true
            });
            track.addEventListener('wheel', requestUpdate, { passive: true });
            track.addEventListener('touchend', requestUpdate, {
              passive: true
            });
            track.addEventListener('pointerup', requestUpdate, {
              passive: true
            });
          });

        window.addEventListener('resize', updateIncludedScrollbars);
        window.requestAnimationFrame(updateIncludedScrollbars);
        window.setTimeout(updateIncludedScrollbars, 300);
      }

      function selectCard(which) {
        var selectOneBed = which === 1;

        card1.classList.toggle('is-selected', selectOneBed);
        card1.classList.toggle('is-collapsed', !selectOneBed);
        card2.classList.toggle('is-selected', !selectOneBed);
        card2.classList.toggle('is-collapsed', selectOneBed);

        window.requestAnimationFrame(updateIncludedScrollbars);
        window.setTimeout(updateIncludedScrollbars, 100);
        window.setTimeout(updateIncludedScrollbars, 400);
      }

      function isInteractiveTarget(target) {
        return Boolean(target.closest('select, button, a, input, label'));
      }

      function renumberBeds() {
        var rows = multiList.children;
        var minimum = parseInt(widget.dataset.minMulti, 10) || 2;

        for (var index = 0; index < rows.length; index += 1) {
          var number = index + 1;
          var numberElement = rows[index].querySelector('.eb-bed-num');
          var select = rows[index].querySelector('[data-role="multi-variant"]');
          var removeButton = rows[index].querySelector('.eb-remove');

          if (numberElement) numberElement.textContent = number;
          if (select) select.setAttribute('aria-label', 'Bed ' + number + ' size');

          if (removeButton) {
            removeButton.disabled = index < minimum;
            removeButton.setAttribute(
              'aria-label',
              'Remove bed ' + number
            );
          }
        }
      }

      function bindRemoveButtons() {
        multiList.querySelectorAll('.eb-remove').forEach(function (button) {
          if (button.dataset.bound) return;
          button.dataset.bound = '1';

          button.addEventListener('click', function () {
            if (button.disabled) return;

            var row = button.closest('.eb-bed-line');
            if (row) row.remove();

            renumberBeds();
            updateMultiPrices();
          });
        });
      }

      card1.addEventListener('click', function (event) {
        if (isInteractiveTarget(event.target)) return;
        selectCard(1);
      });

      card2.addEventListener('click', function (event) {
        if (isInteractiveTarget(event.target)) return;
        selectCard(2);
      });

      singleSelect.addEventListener('change', updateSinglePrice);

      multiList.addEventListener('change', function (event) {
        if (!event.target.matches('[data-role="multi-variant"]')) return;
        updateMultiPrices();
      });

      if (addBedButton) {
        addBedButton.addEventListener('click', function () {
          var sourceRow = multiList.children[0];
          if (!sourceRow) return;

          var clone = sourceRow.cloneNode(true);
          var removeButton = clone.querySelector('.eb-remove');

          if (removeButton) {
            removeButton.disabled = false;
            removeButton.removeAttribute('data-bound');
          }

          multiList.appendChild(clone);
          bindRemoveButtons();
          renumberBeds();
          updateMultiPrices();
        });
      }

      cta.addEventListener('click', function () {
        if (cta.disabled) return;

        cta.disabled = true;
        var originalText = cta.textContent;
        cta.textContent = 'Adding...';

        var items = [];

        if (card1.classList.contains('is-selected')) {
          items.push({
            id: parseInt(singleSelect.value, 10),
            quantity: 1
          });
        } else {
          var counts = {};

          multiList
            .querySelectorAll('[data-role="multi-variant"]')
            .forEach(function (select) {
              var variantId = parseInt(select.value, 10);
              counts[variantId] = (counts[variantId] || 0) + 1;
            });

          Object.keys(counts).forEach(function (variantId) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: counts[variantId]
            });
          });
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error(
                (result.data && result.data.description) ||
                  'Add to cart failed'
              );
            }

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            document.dispatchEvent(new CustomEvent('cart:build'));

            if (
              window.Rebuy &&
              window.Rebuy.SmartCart &&
              typeof window.Rebuy.SmartCart.show === 'function'
            ) {
              window.Rebuy.SmartCart.show();
            } else {
              var cartDrawer = document.querySelector('cart-drawer');

              if (cartDrawer && typeof cartDrawer.show === 'function') {
                cartDrawer.show();
              } else {
                window.location.href = window.Shopify.routes.root + 'cart';
              }
            }

            cta.textContent = originalText;
            cta.disabled = false;
          })
          .catch(function (error) {
            console.error('[Earthbound Bundle]', error);
            alert(
              'Sorry — there was a problem adding to cart: ' +
                error.message
            );
            cta.textContent = originalText;
            cta.disabled = false;
          });
      });

      bindRemoveButtons();
      renumberBeds();
      updateSinglePrice();
      updateMultiPrices();
      initIncludedScrollbars();
    });
  })();
